import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import { Observable } from 'rxjs';
import { RtvAutoCarAssign } from '@bds/railtrac-models';

@Injectable({
    providedIn: 'root',
})
export class RtAutoCarAssignService {
    private readonly baseUrl: string;
    private readonly odataUrl: string;

    constructor(
        private http: HttpClient,
        @Inject('BASE_API_URL') private apibaseUrl: string,
        @Inject('BASE_ODATA_URL') private odatabaseUrl: string,
    ) {
        this.baseUrl = this.apibaseUrl;
        this.odataUrl = this.odatabaseUrl;
    }

    getODataStore(): DataSource {
        return new DataSource({
            store: new ODataStore({
                version: 4,
                url: this.odataUrl + 'autoCarAssign',
                key: 'ormId',
            }),
            paginate: true,
            pageSize: 20,
        });
    }

    createRecord(data: RtvAutoCarAssign): Observable<any> {
        return this.http.post(`${this.baseUrl}autoCarAssign/add`, data);
    }

    deleteRecords(ormIds: number[]): Observable<any> {
        return this.http.delete(`${this.baseUrl}autoCarAssign/delete`, { body: ormIds });
    }
}
